var map = {
	"./ApplicationStatus.vue": [
		3554,
		425
	],
	"./Autosave.vue": [
		3555,
		465
	],
	"./ChangeAuthor.vue": [
		3556,
		466
	],
	"./ChangeType.vue": [
		3557,
		467
	],
	"./Cooldown.vue": [
		3558,
		426
	],
	"./CourseRelease.vue": [
		3559,
		427
	],
	"./Demo.vue": [
		3565,
		514
	],
	"./Demo2.vue": [
		3566,
		515
	],
	"./EditorSettings.vue": [
		3560,
		468
	],
	"./Hint.vue": [
		3553
	],
	"./ModuleRelease.vue": [
		3561,
		428
	],
	"./Practice.vue": [
		3562,
		429
	],
	"./Reorder.vue": [
		3563,
		469
	],
	"./Vacancies.vue": [
		3564,
		470
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 3411;
module.exports = webpackAsyncContext;